// Shared narrative-text sanitization for slide renderers.
//
// Upstream, `llmfill/service.py::_validate_no_llmfill_placeholder` raises rather than
// degrading when a fill leaves the literal "llmfill" placeholder behind, so this check
// should never fire in practice. It exists as defense in depth for headline/title props:
// if a placeholder ever slipped through, this keeps it off the rendered slide instead of
// printing "llmfill" in front of a client.

/**
 * Trims narrative text (headline/title props) and treats a bare, case-insensitive
 * "llmfill" placeholder as absent. Returns `undefined` for blank or placeholder text so
 * callers can fall back the same way they do for any other missing value.
 */
export function sanitizeNarrativeText(value?: string | null): string | undefined {
  const normalized = (value || '').trim()

  if (!normalized || normalized.toLowerCase() === 'llmfill') {
    return undefined
  }

  return normalized
}
